import { memo } from 'react';
import ProcessSupervisionTaskComponent from './ProcessSupervisionTaskComponent';
import { StepViewComponentProps } from '../stepDescriptor/types';

function ProcessSupervisionViewComponent(props: StepViewComponentProps) {
  return <ProcessSupervisionTaskComponent {...props} isPinnable isPinnedView={false} />;
}
export default memo(ProcessSupervisionViewComponent);
